export const LAST_CONTACT_STORAGE_KEY = "salesdemon.lastContactId"
export const LAST_CONTACT_EVENT = "salesdemon:last-contact"

export function rememberLastContact(contactId: string): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(LAST_CONTACT_STORAGE_KEY, contactId)
  window.dispatchEvent(new CustomEvent(LAST_CONTACT_EVENT, { detail: contactId }))
}
